import { render, staticRenderFns } from "./NewsBackEnd.vue?vue&type=template&id=6f40c31a&scoped=true&"
import script from "./NewsBackEnd.vue?vue&type=script&lang=js&"
export * from "./NewsBackEnd.vue?vue&type=script&lang=js&"
import style0 from "./NewsBackEnd.vue?vue&type=style&index=0&id=6f40c31a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f40c31a",
  null
  
)

export default component.exports